module.exports = __webpack_public_path__ + "static/2-1070072f81852b449ee9ddc2c8a845f1.jpg";